




















import Vue from "vue";
import firebase from "@/plugins/firebase";

export default Vue.extend({
  name: "CommonHeader"
});
